import React from "react";

import { images } from "../../constants";
import "./Storybook.css";
import { SubHeading } from "../../components";
import Gallery from "../Gallery/Gallery";

const pic_style = {
  margin: "auto",
};

const side_by_side_style = {
  display: "flex",
};

const Storybook = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_info">
      <h1 className="headtext__cormorant">Storybook</h1>

      <div className="app__author-content">
        <SubHeading title="Background"></SubHeading>
        <div className="app__author-content_quote">
          <p className="p__opensans_lower_case flex__center">
            In the process of conducting interviews with USC faculty in the
            environmental sciences, I was looking for a specific environmental
            issue which could be told to children. Many topics arose, from the
            air quality in the Middle East, the exploitation of natural
            resources (from a study of Moby Dick), the allocation of water,
            climate change impacting kelp forests, to nuclear power plants. The
            list of current day environmental issues went on and on. In
            discussing with my faculty advisors, the topic we decided to focus
            on for this initial story book was light pollution, for the sake of
            considering the complexity of the subject matter and the ability to
            tell an interesting story through the lens of this environmental
            issue (which is very pertinent to any child living in the modern
            world, especially Los Angeles where this project was conceived). The
            overall focus of this aspect of the project was identifying a need
            for children's book literature which focused upon taking one
            specific environmental issue (which children may not be all too
            familiar with), and introducing them to these complex modern day
            phenomena in a way that was engaging, creative, and comprehensible.
          </p>
        </div>
        <SubHeading title="Research" />
        <p className="p__opensans_lower_case flex__center">
          In researching much of the contemporary and currently available
          children’s book literature on sustainability, I was disappointed to
          find that much of the books either steered too far scientifically,
          spoke too broadly/generally about environmental issues (using umbrella
          terms such as “pollution,” or “climate change”), or told stories that
          did not have much depth in storytelling (a particular story about an
          otter untangling itself from ocean trash comes to mind). In writing
          this manuscript I consulted the University of Southern California’s
          rare books and manuscripts collection, reading works such as The
          Little Prince, and works by children's book authors/illustrators such
          as Edward Gorey and Maurice Sendak.
        </p>
        <img
          src={images.TreeBook}
          alt="Page in book with a tree"
          style={pic_style}
        />
        <SubHeading title="Manuscript" />
        <p className="p__opensans_lower_case flex__center">
          “[The night sky through the perspective of a camera] This is what the
          night sky looked like 100 years ago. This is what the night sky looked
          like 30 years ago. This is what the night sky looks like today. Look,
          there are no stars. Look! There! Those two lights! They look very
          pretty–surely those are stars twinkling in the distance— but those
          aren’t stars, they’re satellites. Or, if they’re blinking, it’s an
          airplane. [image of a satellite in the sky] … A long time ago, in a
          Korean village off the province of South Gyeongsang, people used paper
          lanterns to see at night. And every night the people made sure to turn
          off their lanterns, or else their house might catch on fire. [image of
          a burning paper lantern alongside someone reading] The village was
          known for its beautiful landscapes, and many people would visit to go
          hiking. But, what most people did not know, was that the village was
          home to creatures called the Myōjā. They had long, hollow eyes. They
          were as tall as red pine trees. They ate white moths and loved to play
          games with the village children. They went to sleep at night, and woke
          up with the morning sun, the same as the village people. They helped
          pick up trash left by the visiting hikers, and they lifted away heavy
          trees and rocks which fell by the wayside. [...]”
        </p>
        <SubHeading title="Illustrations" />
        <Gallery />
        <SubHeading title="Conceptualization" />
        <div style={side_by_side_style}>
          <img
            src={images.ConceptMyoja}
            alt="Real carving of Myoja for concept"
            style={pic_style}
          />
          <img
            src={images.ConceptScenery}
            alt="Real carving of forest scenery for concept"
            style={pic_style}
          />
        </div>
      </div>
    </div>
  </div>
);

export default Storybook;
